export const colors = {
  light: {
    // Backgrounds
    background: '#160c28',
    backgroundGray: '#ebebeb',
    primaryBackground: '#3548CF',
    secondaryBackground: '#FAFBFF',
    lightBackground: '#F8F9FF',
    grayBackground: '#fafbff',
    articleBackground: '#F8F9FF',
    footer: '#EBF3FA',

    // Primary colors
    primary: '#4357F2',
    primaryDisable: '#ffffff',
    primaryHover: '#3246D0',
    secondary: '#0E1B53',

    // Blues
    darkBlue: '#162154',
    blue: '#0cb5f7',
    lightBlue: '#65d1fa',
    lightBlueText: '#16215480',
    boxInfo: '#dcedfe',
    lightBlueBorder: '#C8DAFE',

    // Grays
    lightGray: '#FAFAFA',
    gray: '#EEEEEE',
    darkGray: '#888888',
    borderGray: '#F6F6F6',
    lightBorder: '#DCDEE5',

    // Status colors
    error: '#F25551',
    success: '#2FE186',
    info: '#323232',
    red: '#F25652',
    green: '#33E085',
    lightGreen: '#9AFBC8',

    // Base colors
    white: '#FFF',
    black: '#000',
    text: '#888888',
  },
};
